import { Box, Container, Typography } from '@mui/material';
import React from 'react';

function InstallPWASafari() {
  return (
    <React.Fragment>
      <Container style={
        {
          marginTop: '1rem',
          marginBottom: '1rem',
        }
      }>
        <Box>
          <Typography variant="h4">Installazione su iOS</Typography>
          <Typography variant="body1">
            Per installare l'applicazione su iOS, premere il pulsante <b>Condividi</b> in basso.
            <img src="/imgs/install-pwa-safari/step1.jpg" alt="iOS Share" style={
              {
                width: '100%',
                margin: '1rem 0',
              }
            } />
          </Typography>
          <Typography variant="body1">
            Nella schermata successiva, selezionare <b>Aggiungi alla schermata Home</b>.
            <img src="/imgs/install-pwa-safari/step2.jpg" alt="iOS Add to Home" style={
              {
                width: '100%',
                margin: '1rem 0',
              }
            } />
          </Typography>
          <Typography variant="body1">
            Nella schermata successiva, premere <b>Aggiungi</b>.
            <img src="/imgs/install-pwa-safari/step3.jpg" alt="iOS Add" style={
              {
                width: '100%',
                margin: '1rem 0',
              }
            } />
          </Typography>
          <Typography variant="body1">
            Complimenti! L'applicazione è stata installata correttamente e può essere utilizzata come una normale applicazione.
          </Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default InstallPWASafari;
